// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursor-copy[data-v-57447b40]{cursor:copy}", ""]);
// Exports
module.exports = exports;
